/**
 * @module common/classes/component
 */

/**
 * @classdesc Класс компоненты
 */
class Component {
  /**
   * Создаёт экземпляр компоненты и добавляет референсы
   * @param {HTMLElement} el - корневой элемент компоненты
   */
  constructor(el) {
    /**
     * @instance
     * @type {HTMLElement}
     * @description Корневой элемент компоненты
     */
    this.el = el;
    /**
     * @instance
     * @type {Map<string:HTMLElement>}
     * @description Референсы
     */
    this.refs = new Map();

    [...el.querySelectorAll('[data-ref]')].forEach((item) => {
      const key = item.dataset.ref;
      this.refs.set(key, item);
    });
  }
}

export default Component;
